<div class="flex items-center gap-16">
  <nz-range-picker
    *ngIf="isDataExplorerSolution"
    twaiceClampDateRange
    [disableDateRangeClamp]="isWarrantySolution"
    [useDataExplorerDate]="true"
    [style.min-width]="'310px'"
    [nzRanges]="ranges"
    nzShowTime
    [nzFormat]="'MMM d, y HH:mm'"
    [(ngModel)]="pickerValue"
    (ngModelChange)="onRangePickerChange($event)"
    [nzMode]="selectedTimeResolution?.value ?? 'date'"
    [nzShowTime]="{ nzFormat: 'HH:mm' }"
    [needConfirm]="false"
  />
  <nz-range-picker
    *ngIf="!isDataExplorerSolution"
    twaiceClampDateRange
    [disableDateRangeClamp]="isWarrantySolution"
    [nzRanges]="ranges"
    nzFormat="MMM d, y"
    [(ngModel)]="pickerValue"
    (ngModelChange)="onRangePickerChange($event)"
    [nzRenderExtraFooter]="footerRender"
    [nzMode]="selectedTimeResolution?.value ?? 'date'"
  />
  <div class="flex items-center gap-4" *ngIf="isDataExplorerSolution">
    <div
      class="flex font-normal text-sm leading-base text-tertiary-text items-center"
      nz-tooltip
      nzTooltipPlacement="bottom"
      nzTooltipTitle="The actual time resolution may be lower than the selected value, depending on data availability"
    >
      <span>Resolution</span>
      <twaice-fe-svg-icon name="info-circle" source="tabler" size="13px" class="block ml-[4px]" />
    </div>
    <nz-select
      class="w-[100px] ml-8"
      [compareWith]="compareTimeResolutionDEFn"
      [(ngModel)]="selectedTimeResolutionDE"
      (ngModelChange)="onTimeResolutionDEChange($event)"
    >
      <nz-option *ngFor="let granularity of timeResolutionDE" [nzValue]="granularity" [nzLabel]="granularity.label"> </nz-option>
    </nz-select>
  </div>
  <ng-template #footerRender>
    <div class="flex flex-col gap-16 px-[4px] py-16" *ngIf="!isDataExplorerSolution">
      <span class="text-base font-semibold">View resolution</span>
      <nz-segmented
        [nzBlock]="true"
        [nzOptions]="timeResolutionMapping"
        [ngModel]="selectedTimeResolution?.value"
        (ngModelChange)="onTimeResolutionChange($event)"
      ></nz-segmented>
    </div>
  </ng-template>
</div>
